<template>
  <div class="leiding-component container">
    <div class="flipper">
      <leiding-image :leiding="leiding" />
    </div>
    <div class="content" :class="leiding.id % 2 == 1 ? 'left' : 'right'">
      <h1>{{ leiding.naam }} - {{ leiding.titel }}</h1>
      <div class="slagzin">
        <div style="max-width: 350px; white-space: normal;">
          {{ leiding.slagzin }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import leidingImage from '@/components/leiding/Image.vue';

export default {
  name: 'individueel',
  props: ['leiding'],
  components: { 'leiding-image': leidingImage },
  //   computed: {
  //     src: () => `/images/leiding/${this.leiding.naam}.jpg`,
  //   },
};
</script>
